// index.js

import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './utils/ScrollToTop';
import { publishFrontendRuntimeIdentity } from './runtime/runtimeIdentity';

publishFrontendRuntimeIdentity(window);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  </HelmetProvider>
);

reportWebVitals();
